webpackJsonp([114276838955818,60335399758886],{

/***/ "./node_modules/json-loader/index.js!./.cache/json/layout-index.json":
/***/ (function(module, exports) {

	module.exports = {"data":{"pages":{"edges":[{"node":{"id":"c63VqLCrq1yCI42SOYOA2Oe","title":"Staff","slug":"staff","subpages":null}},{"node":{"id":"c5qdSHb3Sms8gqm8yYyaOO8","title":"Contact","slug":"contact","subpages":null}},{"node":{"id":"c6R1Zhg6Llek6S6sUcQO48k","title":"Engineering Services","slug":"engineering-services","subpages":null}},{"node":{"id":"c4VrOUS6tluI4SO4YaQ24m4","title":"Field Services","slug":"field-services","subpages":null}},{"node":{"id":"c51qSqtClcIk4QwK8sEGqAG","title":"Services","slug":"services","subpages":[{"id":"c6R1Zhg6Llek6S6sUcQO48k"},{"id":"c4VrOUS6tluI4SO4YaQ24m4"}]}},{"node":{"id":"c3wEhyCmhLimg2kauWUcyIU","title":"Where We Work","slug":"where-we-work","subpages":null}},{"node":{"id":"c7xGYwYRCzSQuqYUGs4GmUy","title":"We provide drilling, completion and fracture stimulation engineering in addition to field supervision services _for oil and gas operations_ around the United States","slug":"index","subpages":[{"id":"LHzLhNsaiIwWkSk6ic8Gi"},{"id":"c51qSqtClcIk4QwK8sEGqAG"},{"id":"c5qdSHb3Sms8gqm8yYyaOO8"}]}},{"node":{"id":"LHzLhNsaiIwWkSk6ic8Gi","title":"Company","slug":"company","subpages":[{"id":"c63VqLCrq1yCI42SOYOA2Oe"},{"id":"c363ZFZRIfYMkUgA0eAykQw"},{"id":"c3wEhyCmhLimg2kauWUcyIU"}]}},{"node":{"id":"c363ZFZRIfYMkUgA0eAykQw","title":"Consultants","slug":"consultants","subpages":null}}]}},"layoutContext":{}}

/***/ }),

/***/ "./node_modules/babel-loader/lib/index.js?{\"plugins\":[\"/opt/build/repo/node_modules/gatsby/dist/utils/babel-plugin-extract-graphql.js\",\"/opt/build/repo/node_modules/babel-plugin-add-module-exports/lib/index.js\",\"/opt/build/repo/node_modules/babel-plugin-transform-object-assign/lib/index.js\"],\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-env/lib/index.js\",{\"loose\":true,\"uglify\":true,\"modules\":\"commonjs\",\"targets\":{\"browsers\":[\"> 1%\",\"last 2 versions\",\"IE >= 9\"]},\"exclude\":[\"transform-regenerator\",\"transform-es2015-typeof-symbol\"]}],\"/opt/build/repo/node_modules/babel-preset-stage-0/lib/index.js\",\"/opt/build/repo/node_modules/babel-preset-react/lib/index.js\"],\"cacheDirectory\":true}!./.cache/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__("./src/layouts/index.js");
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__("./node_modules/json-loader/index.js!./.cache/json/layout-index.json");
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ "./src/assets/images/logo.svg":
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo.604f1f1d.svg";

/***/ }),

/***/ "./src/components/Footer.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFeather = __webpack_require__("./node_modules/react-feather/dist/index.js");
	
	var _config = __webpack_require__("./src/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _contentful = __webpack_require__("./src/utils/contentful.js");
	
	var _FooterModule = __webpack_require__("./src/components/Footer.module.scss");
	
	var _FooterModule2 = _interopRequireDefault(_FooterModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_Component) {
	  _inherits(Footer, _Component);
	
	  function Footer() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Footer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      pages: []
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Footer.prototype.componentWillMount = function componentWillMount() {
	    var indexPage = (0, _contentful.getPageTree)(this.props.pages);
	    this.setState({ pages: [indexPage].concat(indexPage.subpages) });
	  };
	
	  Footer.prototype.render = function render() {
	    var siteName = _config2.default.siteName,
	        _config$contacts = _config2.default.contacts,
	        email = _config$contacts.email,
	        phoneNo = _config$contacts.phoneNo,
	        faxNo = _config$contacts.faxNo,
	        address = _config$contacts.address;
	
	
	    return _react2.default.createElement(
	      'footer',
	      { className: _FooterModule2.default.root },
	      _react2.default.createElement(
	        'div',
	        { className: _FooterModule2.default.sections },
	        _react2.default.createElement(
	          'div',
	          { className: _FooterModule2.default.sectionsContainer },
	          _react2.default.createElement(
	            'div',
	            { className: _FooterModule2.default.section },
	            _react2.default.createElement(
	              'h4',
	              { className: _FooterModule2.default.sectionTitle },
	              siteName
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _FooterModule2.default.description },
	              'We provide drilling, completion and fracture stimulation engineering, as well as field supervision services for our client operators. Our primary expertise is in horizontal drilling and completion operations in the Williston Basin.'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _FooterModule2.default.section },
	            _react2.default.createElement(
	              'h4',
	              { className: _FooterModule2.default.sectionTitle },
	              'Quick Links'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: _FooterModule2.default.quickLinks },
	              this.state.pages.map(function (_ref) {
	                var title = _ref.title,
	                    slug = _ref.slug,
	                    path = _ref.path;
	                return _react2.default.createElement(
	                  'li',
	                  { key: path },
	                  _react2.default.createElement(
	                    'a',
	                    { className: _FooterModule2.default.quickLink, href: path },
	                    _react2.default.createElement(_reactFeather.ChevronRight, null),
	                    ' ',
	                    title
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _FooterModule2.default.section },
	            _react2.default.createElement(
	              'h4',
	              { className: _FooterModule2.default.sectionTitle },
	              'Contact Details'
	            ),
	            _react2.default.createElement(
	              'ul',
	              { className: _FooterModule2.default.contacts },
	              _react2.default.createElement(
	                'li',
	                { className: _FooterModule2.default.contact },
	                _react2.default.createElement(_reactFeather.MapPin, { className: _FooterModule2.default.contactIcon }),
	                _react2.default.createElement(
	                  'address',
	                  { className: _FooterModule2.default.address },
	                  address
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: _FooterModule2.default.contact },
	                _react2.default.createElement(_reactFeather.Phone, { className: _FooterModule2.default.contactIcon }),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:' + phoneNo },
	                  phoneNo
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: _FooterModule2.default.contact },
	                _react2.default.createElement(_reactFeather.Printer, { className: _FooterModule2.default.contactIcon }),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'tel:' + faxNo },
	                  faxNo
	                )
	              ),
	              _react2.default.createElement(
	                'li',
	                { className: _FooterModule2.default.contact },
	                _react2.default.createElement(_reactFeather.Mail, { className: _FooterModule2.default.contactIcon }),
	                _react2.default.createElement(
	                  'a',
	                  { href: 'mailto:' + email },
	                  email
	                )
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _FooterModule2.default.copyright },
	        _react2.default.createElement(
	          'div',
	          { className: _FooterModule2.default.copyrightContainer },
	          '\xA9 ',
	          new Date().getFullYear(),
	          ' ',
	          siteName,
	          ' All rights reserved'
	        )
	      )
	    );
	  };
	
	  return Footer;
	}(_react.Component);
	
	Footer.propTypes = {
	  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
	};
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Footer.module.scss":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----Footer-module---root---29wyW","sections":"src-components----Footer-module---sections---1vUOr","sectionsContainer":"src-components----Footer-module---sectionsContainer---bmXiX","section":"src-components----Footer-module---section---1JbBY","sectionTitle":"src-components----Footer-module---sectionTitle---u1_GQ","copyright":"src-components----Footer-module---copyright---2uglW","copyrightContainer":"src-components----Footer-module---copyrightContainer---1gPKk","description":"src-components----Footer-module---description---mG6yl","quickLinks":"src-components----Footer-module---quickLinks---1j3P1","quickLink":"src-components----Footer-module---quickLink---1RQZm","contacts":"src-components----Footer-module---contacts---247GT","contact":"src-components----Footer-module---contact---2WJ9O","contactIcon":"src-components----Footer-module---contactIcon---2r5r0","address":"src-components----Footer-module---address---1pmD5"};

/***/ }),

/***/ "./src/components/Header.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Header;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFeather = __webpack_require__("./node_modules/react-feather/dist/index.js");
	
	var _config = __webpack_require__("./src/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _logo = __webpack_require__("./src/assets/images/logo.svg");
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _NavBar = __webpack_require__("./src/components/NavBar.js");
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _HeaderModule = __webpack_require__("./src/components/Header.module.scss");
	
	var _HeaderModule2 = _interopRequireDefault(_HeaderModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Header.propTypes = {
	  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
	};
	
	function Header(_ref) {
	  var pages = _ref.pages;
	  var siteName = _config2.default.siteName,
	      _config$contacts = _config2.default.contacts,
	      email = _config$contacts.email,
	      phoneNo = _config$contacts.phoneNo,
	      faxNo = _config$contacts.faxNo,
	      contactsSlug = _config2.default.nav.contactsSlug;
	
	
	  return _react2.default.createElement(
	    'header',
	    { className: _HeaderModule2.default.root },
	    _react2.default.createElement(
	      'div',
	      { className: _HeaderModule2.default.mainBar },
	      _react2.default.createElement(
	        'div',
	        { className: _HeaderModule2.default.mainBarContainer },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _HeaderModule2.default.logo, to: '/' },
	          _react2.default.createElement('img', { src: _logo2.default, alt: siteName })
	        ),
	        _react2.default.createElement(_NavBar2.default, { pages: pages })
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _HeaderModule2.default.topBar },
	      _react2.default.createElement(
	        'div',
	        { className: _HeaderModule2.default.topBarContainer },
	        _react2.default.createElement(
	          'ul',
	          { className: _HeaderModule2.default.contacts },
	          _react2.default.createElement(
	            'li',
	            { className: _HeaderModule2.default.contact },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Phone:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + phoneNo },
	              phoneNo
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _HeaderModule2.default.contact },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'Fax:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + faxNo },
	              faxNo
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            { className: _HeaderModule2.default.contact },
	            _react2.default.createElement(
	              'strong',
	              null,
	              'E-mail:'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'tel:' + email },
	              email
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _HeaderModule2.default.quoteButton, to: '/' + contactsSlug + '/' },
	          _react2.default.createElement(_reactFeather.HelpCircle, null),
	          ' Contact Us'
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Header.module.scss":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----Header-module---root---6F3vS","topBar":"src-components----Header-module---topBar---1jLo9","topBarContainer":"src-components----Header-module---topBarContainer---GqMQA","contacts":"src-components----Header-module---contacts---18zJi","contact":"src-components----Header-module---contact---35HTs","quoteButton":"src-components----Header-module---quoteButton---3jsHO","mainBar":"src-components----Header-module---mainBar---Tco9z","mainBarContainer":"src-components----Header-module---mainBarContainer---jkU7F","logo":"src-components----Header-module---logo---3gwlO"};

/***/ }),

/***/ "./src/components/Layout.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = Layout;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LayoutModule = __webpack_require__("./src/components/Layout.module.scss");
	
	var _LayoutModule2 = _interopRequireDefault(_LayoutModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Layout.propTypes = {
	  Header: _propTypes2.default.func.isRequired,
	  Footer: _propTypes2.default.func.isRequired,
	  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
	  children: _propTypes2.default.node.isRequired
	};
	
	function Layout(_ref) {
	  var Header = _ref.Header,
	      Footer = _ref.Footer,
	      pages = _ref.pages,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    'div',
	    { className: _LayoutModule2.default.root },
	    _react2.default.createElement(Header, { pages: pages }),
	    _react2.default.createElement(
	      'div',
	      { className: _LayoutModule2.default.body },
	      children
	    ),
	    _react2.default.createElement(Footer, { pages: pages })
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/Layout.module.scss":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components----Layout-module---root---iEBEl","body":"src-components----Layout-module---body---2kj0V"};

/***/ }),

/***/ "./src/components/NavBar.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__("./node_modules/classnames/index.js");
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _gatsbyLink = __webpack_require__("./node_modules/gatsby-link/index.js");
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactFeather = __webpack_require__("./node_modules/react-feather/dist/index.js");
	
	var _config = __webpack_require__("./src/config.js");
	
	var _config2 = _interopRequireDefault(_config);
	
	var _contentful = __webpack_require__("./src/utils/contentful.js");
	
	var _NavBarModule = __webpack_require__("./src/components/NavBar.module.scss");
	
	var _NavBarModule2 = _interopRequireDefault(_NavBarModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NavBar = function (_Component) {
	  _inherits(NavBar, _Component);
	
	  function NavBar() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, NavBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      expanded: false,
	      pages: []
	    }, _this.toggle = function () {
	      _this.setState(function (state) {
	        return {
	          expanded: !state.expanded
	        };
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  NavBar.prototype.componentWillMount = function componentWillMount() {
	    var indexPage = (0, _contentful.getPageTree)(this.props.pages);
	    this.setState({ pages: [indexPage].concat(indexPage.subpages) });
	  };
	
	  NavBar.prototype.render = function render() {
	    var expanded = this.state.expanded;
	    var indexSlug = _config2.default.nav.indexSlug;
	
	
	    return _react2.default.createElement(
	      'nav',
	      { className: _NavBarModule2.default.navBar },
	      _react2.default.createElement(
	        'ul',
	        { className: (0, _classnames2.default)(_NavBarModule2.default.nav, expanded && _NavBarModule2.default.navExpanded), onClick: this.toggle },
	        this.state.pages.map(function (_ref) {
	          var title = _ref.title,
	              slug = _ref.slug,
	              path = _ref.path,
	              subpages = _ref.subpages;
	          return _react2.default.createElement(
	            'li',
	            { key: path, className: _NavBarModule2.default.navItem },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: _NavBarModule2.default.navLink,
	                activeClassName: _NavBarModule2.default.navLinkActive,
	                exact: slug === indexSlug,
	                to: path
	              },
	              title,
	              slug !== indexSlug && !!subpages.length && _react2.default.createElement(_reactFeather.ChevronDown, null)
	            ),
	            slug !== indexSlug && !!subpages.length && _react2.default.createElement(
	              'ul',
	              { className: _NavBarModule2.default.subNav },
	              subpages.map(function (_ref2) {
	                var title = _ref2.title,
	                    path = _ref2.path;
	                return _react2.default.createElement(
	                  'li',
	                  { key: path, className: _NavBarModule2.default.subNavItem },
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    {
	                      className: _NavBarModule2.default.subNavLink,
	                      activeClassName: _NavBarModule2.default.navLinkActive,
	                      to: path
	                    },
	                    title
	                  )
	                );
	              })
	            )
	          );
	        })
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: _NavBarModule2.default.toggleButton, onClick: this.toggle },
	        _react2.default.createElement(_reactFeather.MoreVertical, null)
	      )
	    );
	  };
	
	  return NavBar;
	}(_react.Component);
	
	NavBar.propTypes = {
	  pages: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired
	};
	exports.default = NavBar;
	module.exports = exports['default'];

/***/ }),

/***/ "./src/components/NavBar.module.scss":
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"navBar":"src-components----NavBar-module---navBar---fPx_0","nav":"src-components----NavBar-module---nav---qZ1-q","navExpanded":"src-components----NavBar-module---navExpanded---3bHIg","navItem":"src-components----NavBar-module---navItem---2k4Ng","navLink":"src-components----NavBar-module---navLink---3zzCV","subNav":"src-components----NavBar-module---subNav---3EMl0","subNavLink":"src-components----NavBar-module---subNavLink---3ND8f","navLinkActive":"src-components----NavBar-module---navLinkActive---1WYfU","toggleButton":"src-components----NavBar-module---toggleButton---1n6jp"};

/***/ }),

/***/ "./src/layouts/index.js":
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = DefaultLayout;
	
	var _react = __webpack_require__("./node_modules/react/react.js");
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__("./node_modules/prop-types/index.js");
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _contentful = __webpack_require__("./src/utils/contentful.js");
	
	var _Layout = __webpack_require__("./src/components/Layout.js");
	
	var _Layout2 = _interopRequireDefault(_Layout);
	
	var _Header = __webpack_require__("./src/components/Header.js");
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__("./src/components/Footer.js");
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	__webpack_require__("./src/styles/base.scss");
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	DefaultLayout.propTypes = {
	  data: _propTypes2.default.shape({}).isRequired,
	  children: _propTypes2.default.func
	};
	
	function DefaultLayout(_ref) {
	  var data = _ref.data,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    _Layout2.default,
	    {
	      Header: _Header2.default,
	      Footer: _Footer2.default,
	      pages: (0, _contentful.getNodes)(data.pages)
	    },
	    children()
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ }),

/***/ "./src/styles/base.scss":
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-a701eb0f3d99376d0596.js